module.exports = __webpack_public_path__ + "static/media/background-2.273ea1d1.svg";